import React, { useEffect } from 'react';
import { format } from 'date-fns';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from 'client/_redux/reducers';
import { getMyInvoices } from 'client/_redux/actions/auth/invoices';

interface IProps {
  onClose: () => void;
}

const ModalInvoices: React.FC<IProps> = ({ onClose }) => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const { userInvoices } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    dispatch(getMyInvoices());
  }, [dispatch]);

  return (
    <div className="modal-body align-items-center text-dark">
      <div onClick={onClose} className="d-flex flex-row justify-content-start">
        <span className="font-weight-bold h5 title-Report">
          <i className="fas fa-chevron-left mr-1" />
          {t('ProfileContainer.WalletTab.invoicesTitle')}
        </span>
      </div>
      <div className="mx-3 py-3 px-2 text-start report-text">
        {t('ProfileContainer.WalletTab.invoicesDescription')}
      </div>

      <ul className="p-0 report-list">
        {userInvoices?.length ? (
          userInvoices.map((invoice) => (
            <li
              key={invoice._id}
              className="d-flex flex-row align-items-center justify-content-between py-2 border-bottom"
            >
              <div className="d-flex flex-column">
                <span className="font-weight-bold">{invoice.title || `#${invoice.reference}`}</span>
                <small className="text-muted">
                  {invoice.createdAt && format(new Date(invoice.createdAt), 'dd/MM/yyyy')}
                </small>
              </div>
              {invoice.stripeInvoiceUrl && (
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={invoice.stripeInvoiceUrl}
                  className="btn btn-primary btn-sm"
                >
                  <i className="fas fa-file-invoice mr-1" />
                  {t('ProfileContainer.WalletTab.viewInvoice')}
                </a>
              )}
            </li>
          ))
        ) : (
          <li>
            <span className="text-center text-primary p-3 m-auto">
              {t('ProfileContainer.WalletTab.noInvoices')}
            </span>
          </li>
        )}
      </ul>
    </div>
  );
};

export default ModalInvoices;
